export default __webpack_public_path__ + "static/media/hexagon-inner-10.379f9f95.svg";